import { useDataChange } from 'Simple/Data.js'

export function useOnClickInstallmentAmount(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'settings',
    path: 'data.default_payor_schedule.type',
  })

  return function onClick() {
    change('INSTALLMENT_AMOUNT')
  }
}
